import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import introJs from "intro.js";

//imports for content (search client, register client, etc.)
import Profile from "../dashboardContent/core/Profile";
import SearchClient from "../dashboardContent/foodPantry/FP_SearchClient";
import RegisterClient from "../dashboardContent/foodPantry/FP_RegisterClient";
import ManageVolunteers from "../dashboardContent/core/ManageVolunteers";
import PastVolunteers from "../dashboardContent/core/PastVolunteers";
import Reports from "../dashboardContent/foodPantry/reports/Reports";
import FoodPantry from '../dashboardContent/foodPantry/FP_FoodPantry';
import CreateOrganization from "../dashboardContent/core/CreateOrganization";
import ViewOrganizations from "../dashboardContent/core/SearchOrganizations";
import RolesPermissions from "../dashboardContent/core/RolesPermissions";
import StartingContent from "../dashboardContent/core/StartingContent";
import GeneralDashboard from "../dashboardContent/core/generalDashboard/GeneralDashboard";
import PatientTracking from "../dashboardContent/medical/patientTracking/PatientTracking";
import Events from "../dashboardContent/core/events/Events";
import FoodPantryDashboard from "../dashboardContent/foodPantry/Dashboard/FP_FoodPantryDashboard";
import OrgRoles from "../dashboardContent/core/organizationRoles";



const Landing = () => {
  //useState hooks
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [userPermissions, setUserPermissions] = React.useState(null);
  const [showSignOutModal, setShowSignOutModal] = React.useState(false);
  const navigate = useNavigate();

  const masterUrl = process.env.REACT_APP_BACKURL;

  // Sync OrgID cookie with database state on dashboard mount
  useEffect(() => {
    const syncOrgIDCookie = async () => {
      try {
        const response = await axios.get(
          //process.env.REACT_APP_BACKURL + "/api/user/current-org",
          {
            withCredentials: true,
          }
        );

        const { currentOrgID } = response.data;
        const cookieOrgID = Cookies.get("OrgID");

        // If database org differs from cookie, update the cookie
        if (currentOrgID !== cookieOrgID) {
          if (currentOrgID) {
            // Set cookie to the database value
            Cookies.set("OrgID", currentOrgID, { expires: 365, path: "/" });
          } else {
            // Remove cookie if database shows no org
            Cookies.remove("OrgID", { path: "/" });
          }
        }
      } catch (error) {
        console.debug("Could not sync OrgID cookie:", error.message);
      }
    };

    syncOrgIDCookie();
  }, []);

  useEffect(() => { // Code to run only on first page load)
    setLoading(false); // Temporarily disable loading for testing without backend
    //setUserPermissions(["clientSearch", "registerClient", "foodPantry", "reports", "patientTracking", "manageVolunteers", "superDash"]); // Temporarily set permissions for testing without backend

    const checkSession = async () => {
      try {
        let url = masterUrl;

        const response = await axios.get(url + "/api/foodPantry/dashboard", {
          //uncomment for local testing
          withCredentials: true, // Send cookies
        });

        if (response.status !== 200) {
          throw new Error("Session Expired");
        }

        //call user api route to get permissions an store in userPermissions
        const permsResponse = await axios.get(url + "/api/foodPantry/user/perms", {
          withCredentials: true,
        });

        if (permsResponse.status === 200) {
          setUserPermissions(permsResponse.data.permissions);
          //console.log("User permissions:", permsResponse.data.permissions);
        }

        setLoading(false); //Allow content to load

      } catch (error) {
        console.error("Error during session check:", error.message);
        setError("Session expired.  Redirecting to sign in.");
        setTimeout(() => navigate("/signin"), 2000);
      }
    };

    checkSession();
  }, [navigate]);

  async function handleSignOutClick() {
    try {
      const url = process.env.REACT_APP_BACKURL + "/api/foodPantry/user";
      const response = await axios.delete(url, {
        withCredentials: true, // Send cookies
      });

      if (response.status === 200) {
        setShowSignOutModal(false);
        navigate("/");
        Cookies.remove("sessionID");
        Cookies.remove("userID");
        Cookies.remove("clientID");
        Cookies.remove("OrgID");

      } else {
        setError("Sign out failed. Please try again.");
      }
    } catch (error) {
      setError("Error Signing Out");
      console.error(error);
    }
  }

  function handleSignOutRequest() {
    setShowSignOutModal(true);
  }

  useEffect(() => {
    //constants that determine which content is displayed
    if (localStorage.getItem('LastOpenedContent')) {
      setContentOpen(JSON.parse(localStorage.getItem('LastOpenedContent')));

    } else if (userPermissions && userPermissions.includes("clientSearch")) {
      setContentOpen("profile");
    }

  }, [userPermissions]);
  //constants that determine which content is displayed
  // const [contentOpen, setContentOpen] = React.useState("searchClient"); //default is client search

  const [contentOpen, setContentOpen] = React.useState("startingContent");

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Store a variable in localStorage
      localStorage.setItem('LastOpenedContent', JSON.stringify(contentOpen));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [contentOpen]);

  const [sidebarExpanded, setSidebarExpanded] = React.useState(true);

  //functions for search client, register client, food pantry, and organization buttons
  function handleProfileClick() {
    setContentOpen("profile");
    if (window.innerWidth < 1200) sidebarToggle();
  }

  function handleClientSearchClick() {
    setContentOpen("searchClient");
    if (window.innerWidth < 1200) sidebarToggle();
  }

  function handleRegisterClientClick() {
    setContentOpen("registerClient");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleSearchOrganizationsClick() {
    setContentOpen("searchOrganizations");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleCreateOrganizationClick() {
    setContentOpen("createOrganization");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleManageVolunteersClick() {
    setContentOpen("manageVolunteers");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handlePastVolunteersClick() {
    setContentOpen("pastVolunteers");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleReportsClick() {
    setContentOpen("reports");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handlePatientTrackingClick() {
    setContentOpen("patientTracking");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleFoodPantryRootClick() {
    setContentOpen("FoodPantryDashboard");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleFoodPantryClick() {
    setContentOpen("foodPantry");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleOrgRolesClick() {
    setContentOpen("orgRoles");
    if (window.innerWidth < 1200) sidebarToggle();
  }
  function handleRolesPermissionsClick() {
    setContentOpen("rolesPermissions");
    if (window.innerWidth < 1200) sidebarToggle();
  }

   function handleEventsClick() {
     setContentOpen("events");
     if (window.innerWidth < 1200) sidebarToggle();
   }

    function handleDashboardClick() {
      setContentOpen("generalDashboard");
      if (window.innerWidth < 1200) sidebarToggle();
    }


  function sidebarToggle() {
      setSidebarExpanded(!sidebarExpanded);
      if (!sidebarExpanded && window.innerWidth < 1200) {
          document.body.classList.add("overflow-hidden")
          document.querySelector('#sidebar-toggle-button').classList.add("d-none")
      } else {
          document.body.classList.remove("overflow-hidden")
          document.querySelector('#sidebar-toggle-button').classList.remove("d-none")
      }
  }

  useEffect(() => {
    function handleResize() {
      const w = window.innerWidth;
      if (w >= 1200) {
        setSidebarExpanded(true);
        document.body.classList.remove("overflow-hidden")
        document.querySelector('#sidebar-toggle-button').classList.remove("d-none")
      } else {
        setSidebarExpanded(false);
        document.body.classList.remove("overflow-hidden")
         document.querySelector('#sidebar-toggle-button').classList.remove("d-none")
      }
    }
    window.addEventListener("resize", handleResize);
    // Run once on mount to set initial state
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //for passing clientID to Profile.jsx from client search or else where
  const [checkedOutProfileClientIDs, setCheckedOutProfileClientIDs] = useState([]);

  function addCheckedOutProfileClientID(newID) {
    setCheckedOutProfileClientIDs(prevIDs => [newID, ...prevIDs.filter(id => id !== newID)]);
  }

  // In your component state:
  const [profileTourKey, setProfileTourKey] = useState(0);
  const [fullTourNeeded, setFullTourNeeded] = useState(localStorage.getItem("FullTourNeeded") === "true");

  useEffect(() => {
    localStorage.setItem("FullTourNeeded", fullTourNeeded ? "true" : "false");
  }, [fullTourNeeded]);


  //content to be displayed (client search, register client, food pantry, organization, etc.)
  let content;
  if (contentOpen === "profile") {
    content = (
      <Profile
        key={profileTourKey}
        checkedOutProfileClientIDs={checkedOutProfileClientIDs}
        setContentOpen={setContentOpen}
        userPermissions={userPermissions}
        url={masterUrl}
      />
    );
  } else if (contentOpen === "generalDashboard") {
    content = <GeneralDashboard
      contentOpen={contentOpen}
      setContentOpen={setContentOpen}
      addCheckedOutProfileClientID={addCheckedOutProfileClientID}
      userPermissions={userPermissions} />;
  } else if (contentOpen === "events") {
    content = <Events
      contentOpen={contentOpen}
      setContentOpen={setContentOpen}
      addCheckedOutProfileClientID={addCheckedOutProfileClientID}
      userPermissions={userPermissions} />;
  } else if (contentOpen === "searchClient") {
    content = <SearchClient
      contentOpen={contentOpen}
      setContentOpen={setContentOpen}
      addCheckedOutProfileClientID={addCheckedOutProfileClientID}
      userPermissions={userPermissions} />;
  } else if (contentOpen === "registerClient") {
    content = <RegisterClient
      contentOpen={contentOpen}
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
    />;
  } else if (contentOpen === "searchOrganizations") {
    content = <ViewOrganizations
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
    />;
  } else if (contentOpen === "createOrganization") {
    content = <CreateOrganization
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
    />;
  } else if (contentOpen === "manageVolunteers") {
    content = <ManageVolunteers
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
    />;
  } else if (contentOpen === "pastVolunteers") {
    content = <PastVolunteers
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
    />;
  } else if (contentOpen === "reports") {
    content = <Reports
      contentOpen={contentOpen}
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
    />;
  } else if (contentOpen === "foodPantry") {
    content = <FoodPantry
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
    />;
  } else if (contentOpen === "FoodPantryDashboard") {
      content = <FoodPantryDashboard
        contentOpen={contentOpen}
        setContentOpen={setContentOpen}
    />;
  } else if (contentOpen === "rolesPermissions") {
    content = <RolesPermissions
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
      />;
  } else if (contentOpen === "orgRoles") {
    content = <OrgRoles
      setContentOpen={setContentOpen}
      userPermissions={userPermissions}
      />;
  } else if (contentOpen === "startingContent") {
    content = <StartingContent />;
  }



  return (
    <React.Fragment>
      <div
        style={{
          minHeight: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: -1,
          background:
            localStorage.getItem("BurchCoin") === JSON.stringify(true)
              ? "url('./images/PizzaBackground.png')"
              : 'rgb(224, 226, 235)',
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundAttachment: 'fixed', // Add this for the fixed background
        }}
      />
      <div id="Dashboard">
        <nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top d-xl-none" id="sidebar-toggle-button">
            <div class="container-fluid">
                <button 
                    class="btn bg-white rounded-2" 
                    type="button" 
                    onClick={() => {
                        sidebarToggle();
                    }} 
                    aria-controls="sidebarToggle" 
                    aria-expanded="false" 
                    aria-label="Toggle Sidebar"
                    >
                <span class="navbar-toggler-icon"></span>
                </button>
            </div>
        </nav>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <>

            <div className="dashboard-layout">
              {/*{sidebarExpanded && (*/}
              <aside
                className={`sidebar sidebar-default sidebar-white sidebar-base navs-rounded-all no-print${!sidebarExpanded ? ' collapsed' : ''}`}
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className="sidebar-header d-flex align-items-center justify-content-start margin-bottom-0">
                  <a
                    className="navbar-brand"
                    href="/"
                    onClick={() => localStorage.removeItem('LastOpenedContent')}
                  >
                    <img
                      src={
                        localStorage.getItem("BurchCoin") === JSON.stringify(true)
                          ? './images/Burchcoin.png'
                          : './images/BridgingHopeNoWord.svg'
                      }
                      className="img-fluid"
                      alt="logo"
                      style={{ maxHeight: "45px" }}
                    />
                  </a>
                  <h4 className="opacity-75 my-1">
                    <span>
                      Bridging Hope
                    </span>
                  </h4>
                </div>
                <div
                  className="sidebar-body pt-0 data-scrollbar"
                  data-scrollbar="true"
                  tabIndex={-1}
                  style={{ overflowY: "auto", outline: "none", flex: 1 }}
                >
                  <div className="scroll-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="sidebar-list col-12">
                        <div class="accordion col-12" id="sidebar-accordion">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="general-header">
                              <button class="accordion-button bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#general-collapse" aria-expanded="true" aria-controls="general-collapse">
                                General
                              </button>
                            </h2>
                            <div id="general-collapse" class="accordion-collapse collapse show" aria-labelledby="general-header" data-bs-parent="#sidebar-accordion">
                              <div class="accordion-body">
                                <a
                                  href="#profile"
                                  className={`${contentOpen === "profile" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                  onClick={handleProfileClick}
                                >
                                  <i className="bi bi-person-circle me-3"></i>
                                  <span className="item-name">Profile</span>
                                </a>
                              <a
                                href="#events"
                                className={`${contentOpen === "events" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                onClick={handleEventsClick}
                              >
                                <i className="bi bi-calendar-event me-3"></i>
                                <span className="item-name">Events</span>
                              </a>

                              <a
                                    href="#org-search"
                                    className={`${contentOpen === "searchOrganizations" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                    onClick={handleSearchOrganizationsClick}
                                    >
                                    <i className="bi bi-search me-2"></i>
                                    <span className="item-name">Organization Search</span>
                                </a>
                              </div>
                            </div>
                          </div>

                          {userPermissions && (userPermissions.includes("clientSearch") || userPermissions.includes("registerClient") || userPermissions.includes("foodPantry") || userPermissions.includes("reports")) && (
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="inventory-header">
                               <button class="accordion-button collapsed bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#inventory-collapse" aria-expanded="false" aria-controls="inventory-collapse">
                                Inventory
                              </button>
                            </h2>
                            <div id="inventory-collapse" class="accordion-collapse collapse" aria-labelledby="inventory-header" data-bs-parent="#sidebar-accordion">
                              <div class="accordion-body">
                                {userPermissions && userPermissions.includes("clientSearch") && (
                                    <a
                                      href="#client-search"
                                      className={`${contentOpen === "searchClient" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleClientSearchClick}
                                    >
                                      <i className="bi bi-search me-3"></i>
                                      <span className="item-name">Client Search</span>
                                    </a>
                                )}

                                {userPermissions && userPermissions.includes("registerClient") && (
                                    <a
                                      href="#register-client"
                                      className={`${contentOpen === "registerClient" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleRegisterClientClick}
                                    >
                                      <i className="bi bi-clipboard-check me-2"></i>
                                      <span className="item-name">Register Client</span>
                                    </a>
                                )}

                                {userPermissions && userPermissions.includes("foodPantry") && (
                                    <a
                                      href="#inventory"
                                      className={`${contentOpen === "foodPantry" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleFoodPantryClick}
                                    >
                                      <i className="bi bi-basket me-2"></i>
                                      <span className="item-name">Inventory</span>
                                    </a>
                                )}

                                {userPermissions && userPermissions.includes("reports") && (
                                    <a
                                      href="#reports"
                                      className={`${contentOpen === "reports" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleReportsClick}
                                    >
                                      <i className="bi bi-file-text me-2"></i>
                                      <span className="item-name">Reports</span>
                                    </a>
                                )}

                                {userPermissions && userPermissions.includes("reports") && (
                                    <a
                                      href="#inventory-dashboard"
                                      className={`${contentOpen === "FoodPantryDashboard" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleFoodPantryRootClick}
                                    >
                                      <i className="bi bi-bar-chart me-2"></i>
                                      <span className="item-name">Inventory Dashboard</span>
                                    </a>
                                )}
                              </div>
                            </div>
                          </div>
                          )}

                          {userPermissions && userPermissions.includes("patientTracking") && (
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="medical-header">
                              <button class="accordion-button collapsed bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#medical-collapse" aria-expanded="false" aria-controls="medical-collapse">
                                Medical
                              </button>
                            </h2>
                            <div id="medical-collapse" class="accordion-collapse collapse" aria-labelledby="medical-header" data-bs-parent="#sidebar-accordion">
                              <div class="accordion-body">
                                {userPermissions && userPermissions.includes("patientTracking") && (
                                    <a
                                      href="#patient-tracking"
                                      className={`${contentOpen === "patientTracking" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handlePatientTrackingClick}
                                    >
                                      <i className="bi bi-file-text me-2"></i>
                                      <span className="item-name">Patient Tracking</span>
                                    </a>
                                )}
                              </div>
                            </div>
                          </div>
                          )}
                          {userPermissions && userPermissions.includes("manageVolunteers") && (
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="administration-header">
                              <button class="accordion-button collapsed bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#administration-collapse" aria-expanded="false" aria-controls="administration-collapse">
                                Administration
                              </button>
                            </h2>
                            <div id="administration-collapse" class="accordion-collapse collapse" aria-labelledby="administration-header" data-bs-parent="#sidebar-accordion">
                              <div class="accordion-body">

                                {userPermissions && userPermissions.includes("superDash") && (
                                    <a
                                      href="#create-org"
                                      className={`${contentOpen === "createOrganization" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleCreateOrganizationClick}
                                    >
                                      <i className="bi bi-building-add me-2"></i>
                                      <span className="item-name">Create Organization</span>
                                    </a>
                                )}

                                {userPermissions && userPermissions.includes("manageVolunteers") && (
                                    <a
                                      href="#manage-volunteers"
                                      className={`${contentOpen === "manageVolunteers" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleManageVolunteersClick}
                                    >
                                      <i className="bi bi-person-lines-fill me-2"></i>
                                      <span className="item-name">Manage Volunteers</span>
                                    </a>
                                )}

                                {userPermissions && userPermissions.includes("manageVolunteers") && (
                                    <a
                                      href="#past-volunteers"
                                      className={`${contentOpen === "pastVolunteers" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handlePastVolunteersClick}
                                    >
                                      <i className="bi bi-clock-history me-2"></i>
                                      <span className="item-name">Volunteer Hours</span>
                                    </a>
                                )}
                                {userPermissions && userPermissions.includes("promoteOrgMembers") && (
                                    <a
                                      href="#org-roles"
                                      className={`${contentOpen === "orgRoles" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleOrgRolesClick}
                                    >
                                      <i className="bi bi-house me-2"></i>   
                                      <span className="item-name">Organization Roles</span>
                                    </a>
                                )}

                                {userPermissions && userPermissions.includes("superDash") && (
                                    <a
                                      href="#roles-permissions"
                                      className={`${contentOpen === "rolesPermissions" ? "btn btn-primary text-white d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3" : "btn d-flex align-items-center w-100 text-start rounded-2 px-3 py-2 mb-3"}`}
                                      onClick={handleRolesPermissionsClick}
                                    >
                                      <i className="bi bi-shield-check me-2"></i>   
                                      <span className="item-name">Roles & Permissions</span>
                                    </a>
                                )}
                              </div>
                            </div>
                          </div>
                           )}
                        </div>
                    </div>
                  </div>
                </div>
                <div className="text-center py-1 px-2 me-3 no-print">
                  <Link
                    to="/"
                    className="btn text-bg-danger fw-semibold justify-center"                    
                    onClick={(e) => {
                      e.preventDefault();
                      handleSignOutRequest();
                    }}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Sign Out
                  </Link>
                </div>
                <div className="text-center py-2 px-2 me-3 no-print">
                  {/* Guided Tour Button */}
                  <li className="nav-item mt-3 d-flex">
                    {fullTourNeeded ? (
                      <button
                        className="btn btn-warning btn-sm w-100 d-flex align-items-center justify-content-center"
                        style={{ fontWeight: 600 }}
                        type="button"
                        onClick={() => {
                          setFullTourNeeded(false);
                        }}
                        title="Exit guided tour mode"
                      >
                        <i className="bi bi-x-circle me-2" style={{ fontSize: '1.2rem' }}></i>
                        Exit Guided Tour Mode
                      </button>
                    ) : (
                      <button
                        className="btn btn-info btn-sm w-100 d-flex align-items-center justify-content-center"
                        style={{ fontWeight: 600 }}
                        type="button"
                        onClick={() => {
                          const declaration = introJs();
                          declaration.setOptions({
                            steps: [
                              {
                                intro: "This is a guided tour of all that Bridging Hope has to offer, to disengage tour mode simply click button that says \"Exit Guided Tour Mode\" located at the bottom of the sidebar."
                              },
                              {
                                intro: "While this is a guided tour, you can still skip portions of the tour by clicking the dashboard tab you want to skip to however while still in the guided tour mode you will always be prompted with the tour steps have the tour show up, just click the button to exit guided tour mode."
                              }
                            ]
                          });
                          declaration.start();

                          declaration.onExit(() => {
                            setContentOpen("profile");
                            setFullTourNeeded(true);
                            setProfileTourKey(prev => prev + 1);
                          });
                        }}
                        title="Take a full guided tour"
                      >
                        <i className="bi bi-question-circle me-2" style={{ fontSize: '1.2rem' }}></i>
                        Take a Full Guided Tour
                      </button>
                    )}
                    <button 
                        className="btn btn-warning btn-sm w-50 d-flex align-items-center justify-content-center ms-3 d-xl-none"
                        style={{ fontWeight: 600 }}
                        type="button"
                        onClick={() => {
                            sidebarToggle();
                        }}>
                        <i className="bi bi-arrow-left-circle me-2" style={{ fontSize: '1.2rem' }}></i>
                          Close
                    </button>
                  </li>
                </div>
              </aside>
              {/*)}*/}
              <main className="main-content">
                {content}
              </main>
            </div>
          </>
        )}
      </div>

      {/* Sign Out Confirmation Modal */}
      {showSignOutModal && (
        <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header text-white">
                <h5 className="modal-title">Confirm Sign Out</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setShowSignOutModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center">
                <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '2.5rem', marginBottom: '1rem', display: 'block' }}></i>
                <p className="fw-bold">Are you sure you want to sign out?</p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setShowSignOutModal(false)}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={handleSignOutClick}
                >
                  Sign Out
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </React.Fragment >
  );
};

export default Landing;
